import React from "react";
import { FaPhone, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";
import Button from "./Button";

const formatPhoneNumber = (number) => {
  if (!number) return "";

  const digits = number.replace(/\D/g, "");

  if (digits.length === 10) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
  }

  return number;
};

const formatWhatsAppNumber = (number) => {
  if (!number) return "";

  const digits = number.replace(/\D/g, "");

  // Convert South African number from 0XXXXXXXXX
  // to international format 27XXXXXXXXX
  if (digits.startsWith("0") && digits.length === 10) {
    return `27${digits.slice(1)}`;
  }

  return digits;
};

const ProductCard = ({ product, onAdd, onClick }) => {
  const isAvailable = product.is_available;

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-lg border border-gray-300 shadow-sm hover:shadow-md transition flex flex-col w-full max-w-[170px] sm:max-w-[240px] overflow-hidden cursor-pointer"
    >

      {/* IMAGE */}
      <div className="relative w-full aspect-square bg-gray-100 overflow-hidden">

        <img
          src={product.image1}
          alt={product.name}
          className={`w-full h-full object-cover transition duration-300 ${
            !isAvailable
              ? "grayscale-[35%] opacity-70"
              : ""
          }`}
        />

        {/* AVAILABLE BADGE */}
        {isAvailable && (
          <div className="absolute top-2 left-2 px-2.5 py-1 rounded-full bg-green-700 text-white text-[10px] sm:text-xs font-bold tracking-wide shadow-md">
            AVAILABLE
          </div>
        )}

        {/* SOLD DIAGONAL RIBBON */}
        {!isAvailable && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">

            <div className="w-[140%] -rotate-45 bg-red-600/95 text-white text-center py-2 shadow-lg">
              <span className="text-sm sm:text-base font-extrabold tracking-[0.2em]">
                SOLD
              </span>
            </div>

          </div>
        )}

      </div>

      {/* CONTENT */}
      <div className="flex flex-col px-3 py-3 gap-2">

        {/* NAME */}
        <p className="text-sm font-semibold text-gray-800 leading-tight line-clamp-2">
          {product.name}
        </p>

        {/* PRICE */}
        <p
          className={`font-bold text-sm ${
            isAvailable
              ? "text-green-800"
              : "text-gray-500"
          }`}
        >
          R{Number(product.price).toLocaleString("en-ZA", {
            maximumFractionDigits: 0,
          })}
        </p>

        {/* LOCATION */}
        {product.location && (
          <div className="flex items-center gap-1.5 text-xs text-gray-500">
            <FaMapMarkerAlt className="text-green-700 flex-shrink-0" />
            <span>{product.location}</span>
          </div>
        )}

        {/* CONTACT DETAILS */}
        {(product.contact_phone || product.contact_whatsapp) && (
          <div className="border-t border-gray-200 pt-2 mt-1 space-y-1">

            {/* PHONE */}
            {product.contact_phone && (
              <a
                href={`tel:${product.contact_phone}`}
                onClick={(e) => e.stopPropagation()}
                className="flex items-center gap-2 text-xs text-gray-700 hover:text-green-800 transition"
              >
                <FaPhone className="text-green-800 flex-shrink-0" />

                <span>
                  {formatPhoneNumber(product.contact_phone)}
                </span>
              </a>
            )}

            {/* WHATSAPP */}
            {product.contact_whatsapp && (
              <a
                href={`https://wa.me/${formatWhatsAppNumber(
                  product.contact_whatsapp
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="flex items-center gap-2 text-xs text-gray-700 hover:text-green-800 transition"
              >
                <FaWhatsapp className="text-green-700 flex-shrink-0" />

                <span>
                  {formatPhoneNumber(product.contact_whatsapp)}
                </span>
              </a>
            )}

          </div>
        )}

      </div>

      {/* BUTTON - kept for later, currently hidden */}
      <div
        className="hidden px-2 pb-3"
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          onClick={onAdd}
          className="w-full py-2 text-xs sm:text-sm"
        >
          Add to Cart
        </Button>
      </div>

    </div>
  );
};

export default ProductCard;